<template>
	<!--首页-->
	<div class="app" @click="curr==-1">
		<navHeader></navHeader>
		<!--标题-->
		<div class="header_b">
			<img class="img-fluid" style="width: 100%;" src="../../../static/images/news.jpg" />
			<!--小导航-->
			<div class="nav_x">
				<span><img  src="../../../static/images/add.png"/></span>
				<span><a href="/">首页 </a></span>
				<span>/ 产品中心</span>
			</div>
		</div>
		<div class="comtit">
			<span>产品中心</span>
			<span>PRODUCT CENTER</span>
		</div>
		<!--cate-->
		<div class="cate">
			<div class="container" style="position: relative;">
				<!--类目-->
				<div class="row">
					<div class="col" v-for="(item,index) in cateData">
						<div class="cate_li" :class="curr==index?'cate_li_on':''" @click="cateTab(item,index)">{{item.name}}</div>
					</div>
				</div>
				<!--弹窗1  -->
				<div class="row popup">
					<div class="col">
						<div class="cate_list">
							<div v-show="currPop==0" @click="popup(item)" v-for="(item,index) in searchParamList[0]" class="cate_list_li">{{item.attrName}}</div>
						</div>
					</div>
					<div class="col">
						<div class="cate_list">
							<div v-show="currPop==1" @click="popup(item)" v-for="(item,index) in searchParamList[1]" class="cate_list_li">{{item.attrName}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--类容-->
		<div class="container">
			<div class="row cont">
				<div class="col-sm-9 cont_l">
					<div class="row cont_l_row" v-for="(item,index) in productList">
						<div class="left col-4" style="padding-left: 0;"><img class="img-fluid" :src="item.productImageUrl" /></div>
						<div class="right col-6" style="padding-left: 0;">
							<span class=" fontHidden2">{{item.productName}}</span>
							<span>尺寸 : {{item.productSize}}</span>
						</div>
					</div>
					<!--分页-->
			         <div class="pagetion d-flex justify-content-between align-items-end"  v-if="total!=0">
			         	<div class="pagetion_l">
			         		<span @click="reduce"><img src="../../../static/images/left_jian.png"/></span>
			         		<span @click="plus" style="margin-left: 20px;"><img src="../../../static/images/right_jian.png"/></span>
			         	</div>
			         	<div class="pagetion_r"> 
			         		<span class="yuan">{{pageNo}}</span>
			         		<span class="dian" v-if="pageCount>0">...</span>
			         		<span class="yuan" v-if="pageCount>0">{{pageCount}}</span>
			         	</div>
			         </div>
			           <!--没有数据-->
			         <div class="none" v-if="total==0">~ 没有数据 ~</div>
				</div> 

				<div class="col-sm-3 cont_r">
					<div class="tit">新品上市</div>
					<div class="list" v-for="(item,index) in newProductList">
						<div class="img"><img class="img-fluid" :src="item.productImageUrl" /></div>
						<div class="txt fontHidden2">{{item.productName}}</div>
						<div class="pic">尺寸 : {{item.productSize}}</div>
					</div>
				</div>
			</div>
		</div>
		<!--底部-->
		<comFooter></comFooter>
	</div>
</template>
<script>
	import navHeader from '@/components/navHeader/index.vue'
	import comFooter from '@/components/comFooter/index.vue'
	import API from '@/components/api/home'
	export default {
		components: {
			navHeader,
			comFooter
		},
		data() {
			return {
				currPop: -1,
				curr: -1,
				cateData: [{
						name: '所有类型'
					},
					{
						name: '所有规格'
					},
				],
				searchParamList: [],
				newProductList: [],
				productList: [],
				pageSize: 5, // 每页显示数量
				pageNo: 1, //当前页数
				pageCount: '', //总页数
				productTypeId: '',
				productSizeCode: '',
				total:'',
			}
		},
		created() {},
		mounted() {
			let that = this
			that.getInitQuery()
			that.getConditionQuery()
		},
		methods: {
			//分页加
			plus(){
				let that = this
				if(that.pageNo<that.pageCount){
					that.pageNo++ 
					that.getConditionQuery()
				}else{
					   
				}
				
			},
			//分页减
			reduce(){
				let that = this
				if(that.pageNo>1){
					that.pageNo--
					that.getConditionQuery()
				}
			},
			//点击类目
			cateTab(item, index) {
				this.curr = index
				this.currPop = this.curr
			},
			//点击类目list
			popup(item) {
				let that = this
				that.pageNo = 1
				that.cateData[this.curr].name = item.attrName
				that.currPop = -1
				if(that.curr == 0) {
					that.productTypeId = item.productTypeId
				} else if(this.curr == 1) {
					that.productSizeCode = item.productSizeCode
				}
				that.getConditionQuery()
			},
			//初始化产品
			getInitQuery() {
				let that = this
				API.getInitQuery().then(res => {
					that.newProductList = res.data.newProductList
					that.searchParamList = res.data.searchParamList
				})
			},
			//			查询产品
			getConditionQuery() {
				let that = this
				let params = {}  
				params.pageSize = that.pageSize
				params.pageNo = that.pageNo
				params.productTypeId = that.productTypeId,
				params.productSizeCode = that.productSizeCode,
				API.getConditionQuery(params).then(res => {
					that.productList = res.data.productList
					that.pageCount = res.data.pageCount
					that.total = res.data.total
				})
			}
		},
	}
</script>
<style scoped lang="less">
	@w: 19.2vw;
	.pagetion{
		margin-bottom: 20px;
		.pagetion_l{
			span{
				display: inline-block;
			}
		}
		.pagetion_r{
			span{display: inline-block;}
			.yuan{
				width: 30px;
				height: 30px;
				border-radius: 50%;
				background: #8A8A8A; 
				text-align: center;
				line-height: 30px;
				color: #FFFFFF;
				font-size: 18/@w;
				&:nth-child(1){ 
					background: #166BAB;
				}
			}
			.dian{
				font-size: 30px;
				color: #8A8A8A;
			    padding: 0 20px;
			}
		}
	}
	.none{
		text-align: center;
		font-size: 18/@w;
		margin: 200/@w 0;
		color: #616161;
		font-weight: bold;
	}
	.cate {
		.cate_li {
			border: 4/@w solid #D8D8D8;
			text-align: center;
			padding: 20/@w 0;
			color: #8A8A8A;
			font-size: 18/@w;
			cursor: pointer;
		}
		.cate_li_on {
			color: #A38061;
			font-weight: bold;
			border: 4/@w solid #A38061;
			background: rgba(209, 184, 162, 0.2);
		}
	}
	
	.popup {
		position: absolute;
		left: 15px;
		border: 0;
		width: 100%;
		z-index: 99;
	}
	
	.cate_list {
		box-shadow: 1px 1px 10px rgba(0, 0, 0, .1);
		background: #FFFFFF;
		cursor: pointer;
		color: #616161;
		font-size: 18/@w;
		.cate_list_li {
			padding: 0 15/@w;
			box-sizing: border-box;
		}
		.cate_list_li:hover {
			background: rgba(209, 184, 162, 0.2);
			color: #A38061;
		}
	}
	
	.cont {
		margin-top: 10px;
		margin-bottom: 10px;
		.cont_l_row {
			box-shadow: 1px 1px 10px rgba(0, 0, 0, .1);
			cursor: pointer;
			margin: 20/@w 0 20/@w 0;
			.left {
				img {
					min-width: 200/@w;
				}
			}
			.right {
				color: #616161;
				font-size: 18/@w;
				font-weight: bold;
				span {
					&:nth-child(1) {
						margin: 50/@w 0 65/@w 0;
					}
					&:nth-child(2) {
						font-weight: normal;
					}
				}
			}
		}
		.cont_r {
			color: #616161;
			font-size: 18/@w;
			font-weight: bold;
			text-align: center;
			.tit {
				color: #A38061;
				text-align: center;
				margin-top: 20/@w;
			}
			.list {
				margin: 20/@w 0 20/@w 0;
				box-shadow: 1px 1px 10px rgba(0, 0, 0, .1);
			}
			.img {
				img {
					min-width: 200/@w;
				}
			}
			.txt {
				padding: 0 15/@w;
			}
			.pic {
				padding: 0 15/@w 15/@w 15/@w;
				font-size: 18/@w;
				font-weight: normal;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/product/index.vue